import React, { useEffect, useState, useCallback } from "react";
import { useNavigate, useParams } from "react-router-dom";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { useToast } from "../../context/ToastContext";
import { validatePassword } from "../../utils/validationUtils";
import { useLanguage } from "../../context/LanguageContext";
import EmiratesIdUpload from "../common/EmiratesIdUpload";
import { Eye, EyeOff } from "lucide-react";
import {
  createCorporateBuyer,
  updateCorporateBuyer,
  getCorporateBuyerById,
  getParentBuyerLimits,
} from "../../services/coporateIndividualBuyerServices.ts";
import { useAuth } from "../../context/AuthContext";

const INITIAL_FORM_STATE = {
  fullName: "",
  email: "",
  mobileNo: "",
  password: "",
  location: "",
  expiryDate: "",
  creditLimit: "",
  carLimit: "",
  buyerId: "",
  parentId: "",
   nationalId: "", 
};

export default function AddUser() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { translate, language } = useLanguage();
  const { user: authUser } = useAuth();
  const isRTL = language === "ar";


  const [formData, setFormData] = useState(INITIAL_FORM_STATE);
  const [emirateFront, setEmirateFront] = useState(null);
  const [emirateBack, setEmirateBack] = useState(null);
  const { showSuccess, showError } = useToast();
  const [showPassword, setShowPassword] = useState(false);
  const [existingDocuments, setExistingDocuments] = useState({
    front: null,
    back: null,
  });

  const [parentLimits, setParentLimits] = useState({
    deposit: "",
    creditLimit: "",
    carLimit: "",
  });

  const [initialLimits, setInitialLimits] = useState({
    creditLimit: "",
    carLimit: "",
  });
  const [loadingLimits, setLoadingLimits] = useState(false);

  const [submitting, setSubmitting] = useState(false);
  const [messages, setMessages] = useState({ success: "", error: "" });
  const [errors, setErrors] = useState({});

  const isEditMode = Boolean(id);

  const mapDataToForm = useCallback((data) => {
    const documents = data.buyer?.buyerDocuments || [];

    const frontDoc = documents.find(
      (doc) => doc.buyerDocumentType?.slug === "id-front",
    );

    const backDoc = documents.find(
      (doc) => doc.buyerDocumentType?.slug === "id-back",
    );
    setFormData({
      fullName: data.name || "",
      email: data.email || "",
      mobileNo: data.mobileNo || "",
      password: "",
      location: data.location || "",
      expiryDate: data.idExprDate ? data.idExprDate.split("T")[0] : "",
      creditLimit: data.buyer?.buyerLimit?.remainingCreditLimit ?? "",
      carLimit: data.buyer?.buyerLimit?.remainingCarLimit ?? "",
      buyerId: data.buyer?.id || "",
      parentId: data.buyer?.parentId || "",
      nationalId: data.identificationNo || "",
    });
    setInitialLimits({
      creditLimit: data.buyer?.buyerLimit?.remainingCreditLimit ?? "",
      carLimit: data.buyer?.buyerLimit?.remainingCarLimit ?? "",
    });
    console.log(formData);

    setExistingDocuments({
      front: frontDoc || null,
      back: backDoc || null,
    });
  }, []);

  useEffect(() => {
    if (id) {
      getCorporateBuyerById(id)
        .then((res) => mapDataToForm(res.data || res))
        .catch(() =>
          setMessages((prev) => ({
            ...prev,
            error: "Failed to load user data",
          })),
        );
    }
  }, [id, mapDataToForm]);

  useEffect(() => {
    const fetchParentLimits = async () => {
      // Get parent ID: either from formData (edit mode child) or from logged-in user (add mode parent)
      const parentIdToFetch = formData.parentId || authUser?.buyer?.id;

      if (parentIdToFetch) {
        setLoadingLimits(true);
        try {
          const data = await getParentBuyerLimits(Number(parentIdToFetch));
          console.log(data, "api response of get buyerpackage limit :",)


          setParentLimits({
            deposit: data.remainingDeposit || "0",
            creditLimit: data.remainingCreditLimit || "0",
            carLimit: data.remainingCarLimit || "0",
          });
        } catch (err) {
          console.error("Failed to load parent limits:", err);
          // showError("Failed to load parent's remaining limits");
        } finally {
          setLoadingLimits(false);
        }
      }
    };

    fetchParentLimits();
  },
    [formData.parentId, authUser?.buyer?.id]);


  // useEffect(() => {
  //   const fetchParentLimits = async () => {
  //     if (isEditMode && formData.parentId) {
  //       setLoadingLimits(true);
  //       try {
  //         const data = await getParentBuyerLimits(Number(formData.parentId));
  //         console.log("api respsonse of the get parent buyre limit : " , data);
  //         // Assuming API returns single object as in your sample response
  //         setParentLimits({
  //           deposit: data.deposit || "0",
  //           creditLimit: data.creditLimit || "0",
  //           carLimit: data.carLimit || "0",
  //         });
  //       } catch (err) {
  //         console.error("Failed to load parent limits:", err);
  //       } finally {
  //         setLoadingLimits(false);
  //       }
  //     }
  //   };

  //   fetchParentLimits();
  // }, [isEditMode, formData.parentId, showError]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    // Clear error when user types
    if (errors[name]) setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const handlePhoneChange = (value) => {
    setFormData((prev) => ({ ...prev, mobileNo: value ? `+${value}` : "" }));
    if (errors.mobileNo) setErrors((prev) => ({ ...prev, mobileNo: "" }));
  };

  const handleReset = () => {
    setFormData(INITIAL_FORM_STATE);
    setEmirateFront(null);
    setEmirateBack(null);
    setErrors({});
  };

  const validate = () => {
    const newErrors = {};
    if (!formData.fullName.trim())
      newErrors.fullName =
        translate("dashboard.addUser.errors.fullName") ||
        "Full name is required";
    if (!formData.email.trim())
      newErrors.email =
        translate("dashboard.addUser.errors.email") || "Email is required";

        if (!formData.nationalId.trim()) {
  newErrors.nationalId =
    translate("addUser.errorsnationalId") ||
    "National ID is required";
}
    if (!formData.mobileNo || formData.mobileNo.length < 8)
      newErrors.mobileNo =
        translate("dashboard.addUser.errors.phone") ||
        "Valid phone is required";
    if (!isEditMode && !formData.password)
      newErrors.password =
        translate("dashboard.addUser.errors.password") ||
        "Password is required";
    if (!formData.location.trim())
      newErrors.location =
        translate("dashboard.addUser.errors.location") ||
        "Location is required";
    if (!formData.expiryDate)
      newErrors.expiryDate =
        translate("dashboard.addUser.errors.expiryDate") ||
        "Expiry date is required";
    if (!isEditMode) {
      if (!emirateFront)
        newErrors.emirateFront =
          translate("dashboard.addUser.errors.emirateFront") ||
          "National ID Front is required";

    //   if (!emirateBack)
    //     newErrors.emirateBack =
    //       translate("dashboard.addUser.errors.emirateBack") ||
    //       "National ID Back is required";
   }
    if (!isEditMode) {
      const passwordErrorKey = validatePassword(formData.password);
      if (passwordErrorKey) {
        newErrors.password = translate(passwordErrorKey) || "Invalid password";
      }
    } else if (formData.password) {
      const passwordErrorKey = validatePassword(formData.password);
      if (
        passwordErrorKey &&
        passwordErrorKey !== "auth.signup.validation.passwordRequired"
      ) {
        newErrors.password = translate(passwordErrorKey) || "Invalid password";
      }
    }

    const maxCreditLimit = Number(parentLimits.creditLimit) + Number(formData.creditLimit);
    const maxCarLimit = Number(parentLimits.carLimit) + Number(formData.carLimit);

    // Check parent limits
    if (formData.creditLimit !== "" && Number(formData.creditLimit) > maxCreditLimit) {
      newErrors.creditLimit = translate("dashboard.addUser.errors.creditLimitExceeded") || "Cannot exceed available credit limit";
    }

    if (formData.carLimit !== "" && Number(formData.carLimit) > maxCarLimit) {
      newErrors.carLimit = translate("dashboard.addUser.errors.carLimitExceeded") || "Cannot exceed available car limit";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const validateLimit = (field) => {
    const newErrors = { ...errors };

    const parentValue = Number(parentLimits[field] || 0);
    const originalValue = Number(initialLimits[field] || 0);

    const maxAllowed = parentValue + (isEditMode ? originalValue : 0);
    const value = Number(formData[field] || 0);

    if (value > maxAllowed) {
      newErrors[field] =
        translate(`dashboard.addUser.errors.${field}Exceeded`) ||
        `Cannot exceed available ${field === "creditLimit" ? "credit" : "car"
        } limit`;
    } else {
      newErrors[field] = "";
    }

    setErrors(newErrors);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) {
      // Scroll to the first error for better UX
      window.scrollTo({ top: 0, behavior: "smooth" });
      return;
    }

    setSubmitting(true);
    setMessages({ success: "", error: "" });

    try {
      const payload = new FormData();
      payload.append("name", formData.fullName);
      payload.append("email", formData.email);
      payload.append("identificationNo", formData.nationalId);
      payload.append("mobileNo", formData.mobileNo);
      payload.append("location", formData.location);
      payload.append("idExprDate", formData.expiryDate);
      payload.append("assignedCreditLimit", Number(formData.creditLimit) || 0);
      payload.append("assignedCarLimit", Number(formData.carLimit) || 0);

      if (formData.password) payload.append("password", formData.password);
      if (isEditMode && formData.buyerId)
        payload.append("buyerId", formData.buyerId);
      if (isEditMode && formData.parentId)
        payload.append("parentId", formData.parentId);
      if (emirateFront) payload.append("eIdFrontImage", emirateFront);
      if (emirateBack) payload.append("eIdBackImage", emirateBack);

      if (isEditMode && !emirateFront && !emirateBack) {
        if (existingDocuments.front) {
          payload.append("existingDocumentUrls", existingDocuments.front.url);
        }
        if (existingDocuments.back) {
          payload.append("existingDocumentUrls", existingDocuments.back.url);
        }
      }

      if (isEditMode) {
        await updateCorporateBuyer(id, payload);
        showSuccess(
          translate("dashboard.addUser.updateSuccess") ||
          "Buyer updated successfully!"
        );
      } else {
        await createCorporateBuyer(payload);
        showSuccess(
          translate("dashboard.addUser.success") ||
          "Buyer created successfully!"
        );
      }

      setTimeout(() => navigate("/allbuyers"), 1500);
    } catch (err) {


      showError("Something went wrong. Please try again.");
    } finally {
      setSubmitting(false);
    }
  };

  // Helper for dynamic classes
  const inputClass = (fieldName) => `
    w-full border border-default bg-page text-description p-3 rounded-xl transition-all outline-none
    ${errors[fieldName]
      ? "border-red-500 bg-red-50 focus:ring-red-200"
      : "border-default focus:border-blue-500 focus:ring-2 focus:ring-blue-200"
    }
  `;

  return (
    <div
      className={`bg-card rounded-xl min-h-screen ${isRTL ? "rtl" : "ltr"}`}
      dir={isRTL ? "rtl" : "ltr"}
    >
      <div className="max-w-full mx-auto rounded-xl shadow-sm overflow-hidden">
        {/* <div className="bg-primary-soft p-4 md:p-5 border-b">
          <h2 className="text-lg md:text-xl font-bold text-gray-700">
            {isEditMode ? translate("dashboard.addUser.headingEdit") : translate("dashboard.addUser.headingAdd")}
          </h2>
        </div> */}

        <div className="font-medium rounded-t-[8px] sm:rounded-t-[16px]">
          <div className="p-4 sm:p-[20px] text-base sm:text-lg rounded-t-[8px] sm:rounded-t-[12px] font-semibold text-gray-700 bg-primary-soft border-b border-black pb-2">
            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2">
              <h2 className="text-white text-sm sm:text-base md:text-lg font-semibold">
                {isEditMode
                  ? translate("dashboard.addUser.headingEdit")
                  : translate("dashboard.addUser.headingAdd")}
              </h2>
            </div>
          </div>
        </div>

        {messages.success && (
          <div className="m-4 p-3 bg-green-100 text-green-700 rounded-lg text-sm">
            {messages.success}
          </div>
        )}
        {messages.error && (
          <div className="m-4 p-3 bg-red-100 text-red-700 rounded-lg text-sm">
            {messages.error}
          </div>
        )}

        <form
          onSubmit={handleSubmit}
          className="p-4 md:p-6 grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6"
        >
          {/* Full Name */}
          <div className="md:col-span-2">
            <label className="block text-white text-sm font-semibold mb-2">
              {translate("dashboard.addUser.fullName")} *
            </label>
            <input
              name="fullName"
              placeholder={translate("dashboard.addUser.placeholders.fullName")}
              value={formData.fullName}
              onChange={handleChange}
              className={inputClass("fullName")}
            />
            {errors.fullName && (
              <p className="text-red-500 text-xs mt-1">{errors.fullName}</p>
            )}
          </div>

          {/* Email */}
          <div>
            <label className="block text-white text-sm font-semibold mb-2">
              {translate("dashboard.addUser.email")} *
            </label>
            <input
              name="email"
              type="email"
              placeholder={translate("dashboard.addUser.placeholders.email")}
              value={formData.email}
              onChange={handleChange}
              className={inputClass("email")}
            />
            {errors.email && (
              <p className="text-red-500 text-xs mt-1">{errors.email}</p>
            )}
          </div>

          <div>
  <label className="block text-white text-sm font-semibold mb-2">
    {translate("addUser.nationalId") || "National ID"} *
  </label>

<input
    name="nationalId"
    type="text"
    inputMode="numeric"
    placeholder="Enter National ID number"
    value={formData.nationalId}
    onChange={(e) => {
      const value = e.target.value.replace(/\D/g, ""); // ✅ only digits
      setFormData((prev) => ({ ...prev, nationalId: value }));

      if (errors.nationalId) {
        setErrors((prev) => ({ ...prev, nationalId: "" }));
      }
    }}
    className={inputClass("nationalId")}
  />
  {errors.nationalId && (
    <p className="text-red-500 text-xs mt-1">
      {errors.nationalId}
    </p>
  )}
</div>

          {/* Password */}
          {/* Password */}
          <div className="relative">   {/* ← important: relative wrapper */}
            <label className="block text-white text-sm font-semibold mb-2">
              {translate("dashboard.addUser.password")} {!isEditMode && "*"}
              {isEditMode &&
                ` (${translate("dashboard.addUser.placeholders.passwordOptional") || "Optional"})`}
            </label>

            <input
              name="password"
              type={showPassword ? "text" : "password"}           // ← dynamic type
              placeholder={translate("dashboard.addUser.placeholders.password")}
              value={formData.password}
              onChange={handleChange}
              className={inputClass("password")}
            />

            {/* Toggle button / icon */}
            <button
              type="button"                                       // ← very important: prevent form submit
              onClick={() => setShowPassword(prev => !prev)}
              className="absolute right-3 top-[42px] text-gray-400 hover:text-gray-600 focus:outline-none"
              aria-label={showPassword ? "Hide password" : "Show password"}
            >
              {showPassword ? (
                <EyeOff className="h-5 w-5" />
              ) : (
                <Eye className="h-5 w-5" />
              )}
            </button>

            {errors.password && (
              <p className="text-red-500 text-xs mt-1">{errors.password}</p>
            )}
          </div>

          {/* Phone */}
          <div className={`${isRTL ? "phone-input-rtl" : ""}`}>
            <label className="block text-white text-sm font-semibold mb-2">
              {translate("dashboard.addUser.phone")} *
            </label>
            <PhoneInput
              country={"iq"}
              value={formData.mobileNo}
              onChange={handlePhoneChange}
              /* inputClass: added !bg-page, !text-description, and !border-default */
              inputClass={`!w-full !h-[50px] !rounded-xl !transition-all !bg-page !text-description !border-default ${errors.mobileNo ? "!border-red-500 !bg-red-900/20" : ""
                }`}
              containerClass="!w-full"
              /* buttonClass: handles the flag dropdown background and border */
              buttonClass={`!rounded-l-xl !bg-page !border-default ${errors.mobileNo ? "!border-red-500" : ""
                }`}
              /* dropdownClass: handles the menu that pops up when you click the flag */
              dropdownClass="!bg-page !text-description"
              placeholder={translate("dashboard.addUser.placeholders.phone")}
            />
            {errors.mobileNo && (
              <p className="text-red-500 text-xs mt-1">{errors.mobileNo}</p>
            )}
          </div>



          {/* Location */}
          <div className="md:col-span-1">
            <label className="block text-white text-sm font-semibold mb-2">
              {translate("dashboard.addUser.location")} *
            </label>
            <input
              name="location"
              placeholder={translate("dashboard.addUser.placeholders.location")}
              value={formData.location}
              onChange={handleChange}
              className={inputClass("location")}
            />
            {errors.location && (
              <p className="text-red-500 text-xs mt-1">{errors.location}</p>
            )}
          </div>

          {/* Expiry Date */}
          <div className="md:col-span-1">
            <label className="block text-white text-sm font-semibold mb-2">
              {translate("dashboard.addUser.expiryDate")} *
            </label>
            <input
              name="expiryDate"
              type="date"
              value={formData.expiryDate}
              onChange={handleChange}
              className={inputClass("expiryDate")}
            />
            {errors.expiryDate && (
              <p className="text-red-500 text-xs mt-1">{errors.expiryDate}</p>
            )}
          </div>

          {/* Uploads */}
          <div className="bg-page md:col-span-2 grid grid-cols-1 sm:grid-cols-2 gap-4 bg-gray-50 p-4 rounded-xl border border-default">
            <EmiratesIdUpload
              label={translate("dashboard.addUser.emirateIdFront") + " *"}
              file={emirateFront}
              setFile={setEmirateFront}
              existingImageUrl={existingDocuments.front?.url}
            />

            <EmiratesIdUpload
              label={translate("dashboard.addUser.emirateIdBack")}
              file={emirateBack}
              setFile={setEmirateBack}
              existingImageUrl={existingDocuments.back?.url}
            />
          </div>

          {errors.emirateFront && (
            <p className="text-red-500 text-xs mt-1">{errors.emirateFront}</p>
          )}
          {errors.emirateBack && (
            <p className="text-red-500 text-xs mt-1">{errors.emirateBack}</p>
          )}
          {(formData.parentId || authUser?.buyer?.id) && (
            <div className="md:col-span-2 pt-6 border-t border-default">
              <h3 className="font-bold mb-4 text-white text-lg">
                {translate("dashboard.addUser.remainingLimits") ||
                  "Available Distribution Limits (Parent)"}
              </h3>

              {loadingLimits ? (
                <p className="text-gray-500">Loading parent's limits...</p>
              ) : (
                <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 bg-card p-5 rounded-xl border border-default">
                  <div>
                    <label className="block text-xs font-bold uppercase text-white mb-1">
                      {translate("dashboard.addUser.deposit") || "Deposit"}
                    </label>
                    <div className="text-xl font-semibold text-description">
                      {parentLimits.deposit || "0"}
                    </div>
                  </div>

                  <div>
                    <label className="block text-xs font-bold uppercase text-white mb-1">
                      {translate("dashboard.addUser.creditLimit") ||
                        "Credit Limit"}
                    </label>
                    <div className="text-xl font-semibold text-description">
                      {parentLimits.creditLimit || "0"}
                    </div>
                  </div>

                  <div>
                    <label className="block text-xs font-bold uppercase text-white mb-1">
                      {translate("dashboard.addUser.carLimit") || "Car Limit"}
                    </label>
                    <div className="text-xl font-semibold text-description">
                      {parentLimits.carLimit || "0"}
                    </div>
                  </div>
                </div>
              )}
            </div>
          )}

          {/* Limits */}
          <div className="md:col-span-2 pt-4 border-t border-default">
            <h3 className="font-bold mb-4 text-white">
              {translate("dashboard.nav.manageUserLimits") || "User Limits"}
            </h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div>
                <label className="block text-description text-xs font-bold uppercase mb-1">
                  {translate("dashboard.addUser.creditLimitInput")}
                </label>

                <input
                  name="creditLimit"
                  type="number"
                  placeholder="0"
                  value={formData.creditLimit}
                  onChange={handleChange}
                  onBlur={() => validateLimit("creditLimit")}
                  className={`w-full border text-description bg-page p-3 rounded-xl ${errors.creditLimit ? "border-red-500" : "border-default"
                    }`}
                />

                {errors.creditLimit && (
                  <p className="text-red-500 text-xs mt-1">{errors.creditLimit}</p>
                )}

                {/* Info for user */}
                <p className="text-xs text-gray-300 mt-1">
                  Max allowed: {Number(parentLimits.creditLimit) + Number(initialLimits.creditLimit)}
                </p>
              </div>
              <div>
                <label className="block text-xs font-bold uppercase text-description mb-1">
                  {translate("dashboard.addUser.carLimit")}
                </label>
                <input
                  name="carLimit"
                  type="number"
                  placeholder="0"
                  value={formData.carLimit}
                  onChange={handleChange}
                  onBlur={() => validateLimit("carLimit")}
                  className={`w-full border text-description bg-page p-3 rounded-xl ${errors.carLimit ? "border-red-500" : "border-default"}`}
                />
                {errors.carLimit && (
                  <p className="text-red-500 text-xs mt-1">{errors.carLimit}</p>
                )}

                <p className="text-xs text-gray-300 mt-1">
                  Max allowed: {Number(parentLimits.carLimit) + Number(initialLimits.carLimit)}
                </p>
              </div>
            </div>
          </div>

          <div className="md:col-span-2 flex flex-col sm:flex-row gap-3 mt-4">
            <button
              disabled={submitting}
              type="submit"
              className="min-w-[150px] bg-primary text-white px-8 py-4 rounded-xl font-bold hover:bg-primary-dark"
            >
              {submitting
                ? translate("dashboard.addUser.saving")
                : isEditMode
                  ? translate("dashboard.addUser.update")
                  : translate("dashboard.addUser.add")}
            </button>

            {!isEditMode && (
              <button
                type="button"
                onClick={handleReset}
                className="px-10 bg-gray-100 text-gray-600 py-4 rounded-xl font-bold hover:bg-gray-200 transition-all"
              >
                {translate("dashboard.addUser.reset")}
              </button>
            )}
          </div>
        </form>
      </div>
    </div>
  );
  
}
